import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Testimonials() {
  const testimonials = [{
    name: 'Elena M.',
    location: 'CIUDAD DE MÉXICO, MX',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=400&auto=format&fit=crop',
    quote: 'Por primera vez en años, despierto con energía. La niebla mental desapareció por completo y por fin vuelvo a sentirme yo misma.'
  }, {
    name: 'Sara T.',
    location: 'BOGOTÁ, CO',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=400&auto=format&fit=crop',
    quote: "Pensé que mis síntomas eran 'normales' para mi edad. Este método me demostró que no, y me dio los pasos exactos para solucionarlos."
  }, {
    name: 'Lucía R.',
    location: 'BUENOS AIRES, AR',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=400&auto=format&fit=crop',
    quote: 'Sin dietas extremas, sin suplementos raros. Solo hábitos diarios simples que realmente funcionan. Mi hinchazón desapareció en dos semanas.'
  }];
  return <section className="py-20 md:py-32 bg-cream" data-id="element-152">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-153">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-14 md:gap-12" data-id="element-154">
          {testimonials.map((t, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-155">
              <div className="flex flex-col items-center text-center group" data-id="element-156">
                <div className="w-20 h-20 rounded-full overflow-hidden mb-6 shadow-soft group-hover:scale-105 transition-transform duration-500" data-id="element-157">
                  <img src={t.image} alt={t.name} className="w-full h-full object-cover" data-id="element-158" />
                </div>

                <div className="flex gap-1 mb-6" data-id="element-159">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-sand text-sand" data-id="element-160" />)}
                </div>

                <div className="relative mb-8" data-id="element-161">
                  <span className="absolute -top-6 -left-4 font-serif text-6xl text-sand/20 leading-none" data-id="element-162">
                    "
                  </span>
                  <p className="font-serif text-lg md:text-2xl text-ink italic leading-relaxed relative z-10" data-id="element-163">
                    {t.quote}
                  </p>
                </div>

                <div className="mt-auto" data-id="element-164">
                  <p className="text-sm font-medium text-ink mb-1" data-id="element-165">{t.name}</p>
                  <p className="text-xs uppercase tracking-widest text-ink-light" data-id="element-166">
                    {t.location}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}